/* eslint-disable no-alert */
import React, { useContext } from 'react';
import { useFormState } from 'react-final-form';

import { MDText } from 'i18n-react';

import { Button } from '@motorway/mw-highway-code';

import cypressIds from 'CypressId';

import { applyCypressData } from 'Utilities/index';

import LocalTexts from '../DocumentCapture.texts.json';
import DocumentCaptureButtons from '../shared/DocumentCaptureButtons/DocumentCaptureButtons';

import { ADD_BANK_DETAILS_ACTION_TYPE, COP_RESPONSE_MESSAGES } from './AddBankDetails.helpers';
import { AddBankDetailsContext, AddBankDetailsContextType } from './AddBankDetailsContext';

import styles from './AddBankDetailsFormButtons.scss';

const LocalT = new MDText(LocalTexts);

export const AddBankDetailsFormButtons = ({ openContinueModal } : { openContinueModal: () => void}) => {
  const { action, allowContinue, message }: AddBankDetailsContextType = useContext(AddBankDetailsContext);
  const { invalid, modified, submitting } = useFormState();

  const wasFormModified = modified !== undefined && Object.values(modified).some((v) => v === true);

  const hideMessage = [ADD_BANK_DETAILS_ACTION_TYPE.CLEAR,
    ADD_BANK_DETAILS_ACTION_TYPE.MASK].includes(
    action as typeof ADD_BANK_DETAILS_ACTION_TYPE.CLEAR | typeof ADD_BANK_DETAILS_ACTION_TYPE.MASK,
  );

  const isNotEnrolled = message === COP_RESPONSE_MESSAGES.NOT_ENROLLED;

  const getSubmitButtonLabel = () => {
    if (submitting) {
      return 'submitting';
    }

    if (message === COP_RESPONSE_MESSAGES.NOT_ENROLLED) {
      return 'checkNewBankDetails';
    }

    if (action) {
      return 'checkAgain';
    }

    return 'submitAndContinue';
  };

  const isDisabledForNotEnrolled = (isNotEnrolled && !wasFormModified);

  return (
    <>
      {!hideMessage && <p className={styles.securityCopy}>{LocalT.translate('securityCopy')}</p>}
      <DocumentCaptureButtons>
        <Button
          fullWidth
          {...applyCypressData(cypressIds.buttons.submitAndContinue)}
          disabled={submitting || isDisabledForNotEnrolled}
          icon="chevron"
          label={LocalT.translate(getSubmitButtonLabel())}
          type="submit"
        />
        {action === ADD_BANK_DETAILS_ACTION_TYPE.MASK && allowContinue ? (
          <Button
            fullWidth
            disabled={wasFormModified || invalid || submitting}
            label={LocalT.translate('continueWithEntered')}
            onClick={openContinueModal}
            variant="secondary"
          />
        ) : null}
      </DocumentCaptureButtons>
    </>
  );
};
